//Frontend/src/admin/SMSManagement.js
import React, { useState, useEffect } from 'react';
import axiosInstance from '../axios';
import { 
  FaPlus, FaTrash, FaSearch, FaSync, FaMobileAlt, 
  FaTimes, FaCheckCircle, FaClock, FaEdit, FaSave,
  FaExclamationCircle
} from 'react-icons/fa';

export default function SMSManagement() {
  const [smsList, setSmsList] = useState([]);
  const [stats, setStats] = useState({});
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  // Add SMS modal
  const [showAddModal, setShowAddModal] = useState(false);
  const [cargo_code, setCargoCode] = useState(''); 
  const [cargo_id, setCargoId] = useState('');  // 🆕 НЭМЭХ
  const [recipient_phone, setRecipientPhone] = useState('');
  const [message_body, setMessageBody] = useState('');
  const [cargoList, setCargoList] = useState([]);  // 🆕 НЭМЭХ
  
  // Template modal
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  
  // Instructions modal
  const [showInstructions, setShowInstructions] = useState(false);

  useEffect(() => {
  fetchSMS();
  fetchStats();
  fetchTemplates();
  fetchCargoList(); 
}, [page, search]);

// 🆕 НЭМЭХ - Ачааны жагсаалт татах функц
const fetchCargoList = async () => {
  try {
    const res = await axiosInstance.get('/api/cargo-new', {
      params: { page: 1, page_size: 100 }
    });
    setCargoList(res.data.data || []);
  } catch (error) {
    console.error('Cargo list error:', error);
  }
};

  const fetchSMS = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/api/sms-queue', {
        params: { page, page_size: 30, search }
      });
      setSmsList(res.data.data);
      setTotalPages(res.data.total_pages);
    } catch (error) {
      console.error('Fetch SMS error:', error);
      alert('SMS татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await axiosInstance.get('/api/sms-queue/stats');
      setStats(res.data.data);
    } catch (error) {
      console.error('Stats error:', error);
    }
  };

  const fetchTemplates = async () => {
    try {
      const res = await axiosInstance.get('/api/sms-templates');
      setTemplates(res.data.data);
    } catch (error) {
      console.error('Templates error:', error);
    }
  };

  const handleAddSMS = async (e) => {
  e.preventDefault();
  
  if (!recipient_phone || !message_body) {
    alert('Утасны дугаар болон агуулга оруулна уу');
    return;
  }
  
  try {
    await axiosInstance.post('/api/sms-queue', { 
      cargo_id: cargo_id || null,  // 🆕 НЭМЭХ
      cargo_code, 
      recipient_phone, 
      message_body 
    });
    alert('SMS амжилттай нэмэгдлээ');
    setShowAddModal(false);
    setCargoCode('');
    setCargoId('');  // 🆕 НЭМЭХ
    setRecipientPhone('');
    setMessageBody('');
    fetchSMS();
    fetchStats();
  } catch (error) {
    console.error('Add SMS error:', error);
    alert('SMS нэмэхэд алдаа гарлаа');
  }
};

  const handleDelete = async (id) => {
    if (!window.confirm('Үнэхээр устгах уу?')) return;
    
    try {
      await axiosInstance.delete(`/api/sms-queue/${id}`);
      alert('SMS амжилттай устгагдлаа');
      fetchSMS();
      fetchStats();
    } catch (error) {
      console.error('Delete error:', error);
      alert('Устгахад алдаа гарлаа');
    }
  };

  const handleUpdateTemplate = async (template) => {
    if (!template.template_body.trim()) {
      alert('Загварын агуулга оруулна уу');
      return;
    }
    
    try {
      await axiosInstance.put(`/api/sms-templates/${template.id}`, {
        template_body: template.template_body
      });
      alert('Загвар амжилттай шинэчлэгдлээ');
      setShowTemplateModal(false);
      setEditingTemplate(null);
      fetchTemplates();
    } catch (error) {
      console.error('Update template error:', error);
      alert('Загвар шинэчлэхэд алдаа гарлаа');
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchSMS();
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleString('mn-MN');
  };

  const getStatusBadge = (status) => {
    switch(status) {
      case 'sent':
        return <span className="px-2 py-1 text-xs font-semibold rounded bg-green-100 text-green-800 flex items-center gap-1 w-fit">
          <FaCheckCircle /> Илгээсэн
        </span>;
      case 'failed':
        return <span className="px-2 py-1 text-xs font-semibold rounded bg-red-100 text-red-800 flex items-center gap-1 w-fit">
          <FaExclamationCircle /> Алдаатай
        </span>;
      default:
        return <span className="px-2 py-1 text-xs font-semibold rounded bg-orange-100 text-orange-800 flex items-center gap-1 w-fit">
          <FaClock /> Хүлээгдэж байна
        </span>;
    }
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 flex items-center">
          <FaMobileAlt className="mr-3 text-blue-600" />
          SMS удирдлага
        </h1>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-sm text-gray-500">Нийт SMS</div>
            <div className="text-2xl font-bold text-gray-800">{stats.total || 0}</div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-sm text-gray-500">Хүлээгдэж байна</div>
            <div className="text-2xl font-bold text-orange-600 flex items-center">
              <FaClock className="mr-2" />
              {stats.pending || 0}
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-sm text-gray-500">Илгээсэн</div>
            <div className="text-2xl font-bold text-green-600 flex items-center">
              <FaCheckCircle className="mr-2" />
              {stats.sent || 0}
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <div className="text-sm text-gray-500">Алдаатай</div>
            <div className="text-2xl font-bold text-red-600 flex items-center">
              <FaExclamationCircle className="mr-2" />
              {stats.failed || 0}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => setShowAddModal(true)}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 flex items-center gap-2"
          >
            <FaPlus /> Нэмэх
          </button>
          <button
            onClick={fetchSMS}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
          >
            <FaSync /> Шинэчлэх
          </button>
          <button
            onClick={() => setShowTemplateModal(true)}
            className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 flex items-center gap-2"
          >
            <FaEdit /> SMS Загвар
          </button>
          <button
            onClick={() => setShowInstructions(true)}
            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            APP заавар
          </button>
        </div>
      </div>

      {/* Search */}
      <form onSubmit={handleSearch} className="mb-6">
        <div className="flex gap-2">
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Утас, код, агуулгаар хайх..."
            className="flex-1 px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 flex items-center gap-2"
          >
            <FaSearch /> Хайх
          </button>
        </div>
      </form>

      {/* SMS List */}
      {loading ? (
        <div className="text-center py-8">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        </div>
      ) : smsList.length > 0 ? (
        <>
          <div className="bg-white rounded-lg shadow overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Огноо</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Төлөв</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Код</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Хэнд утас</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">SMS агуулга</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Үүсгэсэн</th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Үйлдэл</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {smsList.map((sms) => (
                  <tr key={sms.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {formatDate(sms.created_at)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {getStatusBadge(sms.status)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-mono text-blue-600">
                      {sms.cargo_code || '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {sms.recipient_phone}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 max-w-md truncate">
                      {sms.message_body}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {sms.created_by_name || '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <button
                        onClick={() => handleDelete(sms.id)}
                        className="text-red-600 hover:text-red-900"
                        title="Устгах"
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="mt-6 flex justify-center gap-2">
              <button
                onClick={() => setPage(Math.max(1, page - 1))}
                disabled={page === 1}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
              >
                Өмнөх
              </button>
              <span className="px-4 py-2">
                {page} / {totalPages}
              </span>
              <button
                onClick={() => setPage(Math.min(totalPages, page + 1))}
                disabled={page === totalPages}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
              >
                Дараах
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-8 text-gray-500">
          Мэдээлэл байхгүй
        </div>
      )}

      {/* Add SMS Modal */}
        {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">SMS нэмэх</h2>
                <button
                onClick={() => {
                    setShowAddModal(false);
                    setCargoCode('');
                    setCargoId('');
                    setRecipientPhone('');
                    setMessageBody('');
                }}
                className="text-gray-500 hover:text-gray-700"
                >
                <FaTimes className="w-5 h-5" />
                </button>
            </div>

            <form onSubmit={handleAddSMS}>
                {/* Ачааны код хайх */}
                <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ачааны код хайх (заавал биш)
                </label>
                <input
                    type="text"
                    value={cargo_code}
                    onChange={(e) => {
                    const searchValue = e.target.value;
                    setCargoCode(searchValue);
                    
                    // Хайлт хийх
                    if (searchValue.length >= 3) {
                        const foundCargo = cargoList.find(c => 
                        c.cargo_code.toLowerCase().includes(searchValue.toLowerCase())
                        );
                        
                        if (foundCargo) {
                        setCargoId(foundCargo.id);
                        setRecipientPhone(foundCargo.receiver_phone || '');
                        } else {
                        setCargoId('');
                        }
                    } else {
                        setCargoId('');
                    }
                    }}
                    className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="exp231018-2 гэх мэт бич..."
                />
                <p className="text-xs text-gray-500 mt-1">
                    💡 3+ үсэг бичвэл автоматаар хайна
                </p>
                
                {/* Олдсон ачаа харуулах */}
                {cargo_code.length >= 3 && cargo_id && (
                    <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded text-sm">
                    <div className="flex items-center gap-2 text-green-700">
                        <FaCheckCircle />
                        <span className="font-semibold">Ачаа олдлоо!</span>
                    </div>
                    {cargoList.find(c => c.id === cargo_id) && (
                        <div className="mt-1 text-gray-600">
                        <div>Хүлээн авагч: {cargoList.find(c => c.id === cargo_id).receiver_name}</div>
                        <div>Утас: {cargoList.find(c => c.id === cargo_id).receiver_phone}</div>
                        </div>
                    )}
                    </div>
                )}
                
                {/* Ачаа олдоогүй */}
                {cargo_code.length >= 3 && !cargo_id && (
                    <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded text-sm text-yellow-700">
                    ⚠️ Ачаа олдсонгүй. Гараар утас оруулна уу.
                    </div>
                )}
                </div>

                {/* Утасны дугаар */}
                <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Илгээх утасны дугаар <span className="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    value={recipient_phone}
                    onChange={(e) => setRecipientPhone(e.target.value)}
                    className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="88001234 эсвэл 01012345678"
                    required
                />
                </div>

                {/* SMS агуулга */}
                <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    SMS агуулга <span className="text-red-500">*</span>
                </label>
                <textarea
                    value={message_body}
                    onChange={(e) => setMessageBody(e.target.value)}
                    rows="5"
                    className="w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Сайн байна уу..."
                    required
                />
                <div className="text-xs text-gray-500 mt-1">
                    {message_body.length} тэмдэгт
                </div>
                </div>

                {/* Товчнууд */}
                <div className="flex gap-3">
                <button
                    type="submit"
                    className="flex-1 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 flex items-center justify-center gap-2"
                >
                    <FaPlus /> Нэмэх
                </button>
                <button
                    type="button"
                    onClick={() => {
                    setShowAddModal(false);
                    setCargoCode('');
                    setCargoId('');
                    setRecipientPhone('');
                    setMessageBody('');
                    }}
                    className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
                >
                    Хаах
                </button>
                </div>
            </form>
            </div>
        </div>
        )}

      {/* Template Modal */}
      {showTemplateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold">SMS Загвар засах</h2>
              <button
                onClick={() => {
                  setShowTemplateModal(false);
                  setEditingTemplate(null);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>
            
            <div className="space-y-4">
              {templates.map((template) => (
                <div key={template.id} className="border rounded-lg p-4">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <h3 className="font-semibold text-gray-800">{template.template_name || template.title}</h3>
                      <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-800">
                        Template #{template.id}
                      </span>
                    </div>
                    {editingTemplate?.id === template.id ? (
                      <button
                        onClick={() => handleUpdateTemplate(editingTemplate)}
                        className="text-green-600 hover:text-green-800"
                      >
                        <FaSave className="w-5 h-5" />
                      </button>
                    ) : (
                      <button
                        onClick={() => setEditingTemplate({
                          ...template,
                          template_body: template.template_body || template.body
                        })}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <FaEdit className="w-5 h-5" />
                      </button>
                    )}
                  </div>
                  
                  {editingTemplate?.id === template.id ? (
                    <textarea
                      value={editingTemplate.template_body}
                      onChange={(e) => setEditingTemplate({
                        ...editingTemplate,
                        template_body: e.target.value
                      })}
                      rows="4"
                      className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  ) : (
                    <div className="bg-gray-50 p-3 rounded text-sm whitespace-pre-wrap">
                      {template.template_body || template.body}
                    </div>
                  )}
                  
                  <p className="text-xs text-gray-500 mt-2">
                    💡 <code>{'{kod}'}</code> гэж бичсэн газар ачааны код орно
                  </p>
                </div>
              ))}
            </div>
            
            <button
              onClick={() => {
                setShowTemplateModal(false);
                setEditingTemplate(null);
              }}
              className="mt-6 w-full px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            >
              Хаах
            </button>
          </div>
        </div>
      )}

      {/* Instructions Modal */}
      {showInstructions && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">APP заавар</h2>
            <div className="prose">
              <p>1. Android утсан дээрээс Chrome оор орж <a href="https://www.jimguntrade.com/appsms/sms-app.apk" className="text-blue-600" target="_blank" rel="noopener noreferrer">https://www.jimguntrade.com/appsms/sms-app.apk</a> хаягаар APP аа татаж суулгана.</p>
              <p className="mt-4">2. App-ынхаа тохиргоо руу орж:</p>
              <ol className="list-decimal ml-6 space-y-2">
                <li>SMS permission шалгах товчыг дарна.</li>
                <li>JSON татах URL хаяг = <code className="bg-gray-100 px-2 py-1 rounded">{window.location.origin}/api/sms-queue/fetch</code></li>
                <li>Чагнах давтамж = 3-5</li>
                <li>Тухайн утасны дугаараа оруулна.</li>
                <li>Хадгалах товчыг дарна.</li>
              </ol>
            </div>
            <button
              onClick={() => setShowInstructions(false)}
              className="mt-6 px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            >
              Хаах
            </button>
          </div>
        </div>
      )}
    </div>
  );
}